export default __webpack_public_path__ + "static/media/fabula_mob_banner_1.66394c16.png";